export type Listeners = Record<string, Function>;

export type UseListeners = {
    listenersNames: ComputedRef<string[]>;
    listeners: ComputedRef<Listeners>;
    hasAnyListener: ComputedRef<boolean>;
};

const listenerRegex = /on[A-Z]/;

export const useListeners = (): UseListeners => {
    const attrs = useAttrs();

    const listenersNames = computed(() => {
        const attrsKeys = Object.keys(attrs);

        return attrsKeys.filter((attr: string) => {
            return (
                listenerRegex.test(attr) && typeof attrs[attr] === 'function'
            );
        });
    });

    const listeners = computed(() => {
        const listeners: Listeners = {};
        listenersNames.value.forEach((attr: string) => {
            listeners[attr] = attrs[attr] as Function;
        });
        return listeners;
    });

    const hasAnyListener = computed(() => {
        return listenersNames.value.length > 0;
    });

    return {
        listenersNames,
        listeners,
        hasAnyListener,
    };
};
